import { defineMessages } from 'dibs-react-intl';

// define page types here--maybe move to constants file?
export const FEATURED = 'featured';
export const MARKET = 'market';
export const CREATORS = 'creators';
export const EXHIBITIONS = 'exhibitions';
export const SINGLE_EXHIBITION = 'single-exhibition';
export const SEARCH = 'search';
export const PAGE_TYPES = [
    FEATURED,
    MARKET,
    CREATORS,
    EXHIBITIONS,
    SINGLE_EXHIBITION,
    SEARCH,
] as const;

export type PageType = (typeof PAGE_TYPES)[number];

export const pageTypeGuard = (arg: unknown): arg is PageType =>
    typeof arg !== 'string' ? false : PAGE_TYPES.includes(arg as PageType);

export const pageTypeMessages: {
    [key in PageType]: { defaultMessage: string; id: string };
} = defineMessages({
    featured: { defaultMessage: 'Featured', id: 'NftLanding.usePageType.featured' },
    market: { defaultMessage: 'Market', id: 'NftLanding.usePageType.market' },
    creators: { defaultMessage: 'Creators', id: 'NftLanding.usePageType.creators' },
    exhibitions: { defaultMessage: 'Exhibitions', id: 'NftLanding.usePageType.exhibitions' },
    'single-exhibition': {
        defaultMessage: 'Single Exhibition',
        id: 'NftLanding.usePageType.singleExhibition',
    },
    search: { defaultMessage: 'Search', id: 'NftLanding.usePageType.search' },
});
